export enum IntentTypeEnum {
  payment = 'payment',
  setup = 'setup',
}
